import { useState } from "react"
import { upsert } from "../hooks/useQueryData"
import { NowDB } from "../utils"
import { ActivitySection } from "../lists/ActivityList"
import { SESSION_SERVICE } from "../services/SessionService"
import { ActivityRecord } from "../models/Activity"
import useList from "../hooks/useList"
import { merge } from "lodash"

export const UserActivityTaskSettings = {size: "medium", title: "User Activity Task"}

const userName = SESSION_SERVICE.getCurrentSession().user?.fullName

export default function UserActivityTask({values, setMessage, execRef}: {values: any, setMessage: (s: string, t: string) => void, execRef: React.MutableRefObject<() => Promise<string>>}) {
    setMessage("Enter a non-case specific Activity", "info")
    const newActivity = {Type: "Note",  Description: "", On: NowDB(), ForId: "", CaseId: "",createdBy: userName, updatedBy: userName} as ActivityRecord
    const [ activity, setActivity ] = useState<ActivityRecord>(newActivity)

      let options = useList("UserActivity")
    
    let valid = true
    function validate(value: string, label: string): boolean {
        return !!value
        // const thisValid: boolean = value?.length > 0
        // if (!thisValid) {valid = false; setMessage("Please provide values for all required fields")}

        // return thisValid
    }

    async function execute(): Promise<string> {
        // Check for valid values
        if (!activity?.Description) return "ERROR: Please provide a description for this message"
        if (!activity?.Type) return "ERROR: Please provide a type for this message"

        // Create Activity
        const newId = await upsert('Activity', activity)
        if (!newId) return 'ERROR: Error creating Activity'

        return '' // No error. Successful execution
    }
    execRef.current = execute
    
    const handleChange = (newValues: Object) => {
        setActivity(merge({}, activity, newValues))
    }

    return (
        <ActivitySection activity={activity} handleChange={handleChange} 
            validate={validate} readOnly={false} options={options} />
    )
}
